<script lang="ts">
    import {Flex} from 'shared/layouts';
    import KpHorizontalSeparator from 'shared/ui-widgets/separator/KpHorizontalSeparator.svelte';
    import {exists} from 'shared/utils/custom-utils';

    export let sectionClass: string;
    export let title: string | null = null;
    export let withoutSeparator = false;
</script>

<section class="erp-titled-section {sectionClass}">
    {#if !withoutSeparator}
        <KpHorizontalSeparator marginVertical="0px"/>
    {/if}

    {#if exists(title)}
        <Flex alignItems="center">
            <h2 class:top-margined={!withoutSeparator}>{title}</h2>

            {#if exists($$slots['header-additional-content'])}
                <slot name="header-additional-content"/>
            {/if}
        </Flex>
    {/if}

    <slot/>
</section>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .erp-titled-section {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: @spacing-l;

        h2 {
            flex: 1;
            margin: 0;
            font-size: @font-size-xl;

            &.top-margined {
                margin-top: @spacing-s;
            }
        }
    }
</style>